import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import RemainingFieldList from 'Components/UI/Meta/MetaForm/Components/MetaLayout/RemainingFieldList';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = (theme) => ({
  root: {},
  body: {
    padding: theme.spacing(0),
  },
  alert: {
    marginBottom: theme.spacing(4),
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const { setPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const {
    resource,
  } = useMetaLayoutContext();

  const [saving, setSaving] = useState(false);

  const handleOnSubmit = async () => {
    try {
      setSaving(true);
      const resp = await resource.submit(); // <---- TODO
      setPageContentCollection(resp);
      setSaving(false);
    } catch (err) {
      displayErrorMessage(err, err.errors);
      setSaving(false);
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <RemainingFieldList
        className={classes.fields}
        MetaControlFieldProps={{
          hideViaMetaOverride: true,
        }}
      />
      <RoundedButton
        fullWidth
        isLoading={saving}
        onClick={handleOnSubmit}
      >
        {'Submit'}
      </RoundedButton>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
